<template>
    <div class="form-group">
        <div class="">
            <div class="form-group inputDnD mb-3">
                <input type="file" class="w-100 form-control-file text-primary font-weight-bold"
                id="inputFile" accept="application/pdf" @change="readUrl" data-title="ドラッグ＆ドロップ" multiple>
            </div>
            <div v-for="file in files" :key="file.name">
                {{file.name}}
            </div>
            <div class="text-right">
                <button type="button" class="btn btn-primary btn-block" onclick="document.getElementById('inputFile').click()">参照</button>
                <button type="button" class="btn btn-primary btn-block" @click="upload">アップロード</button>
            </div>
            <div>{{this.message}}</div>
        </div>
    </div>
</template>

<script>
import utils from '../utils/utils.js';

export default {
    name: "FileUpload",
    props: {
        bucketname: {type:String, required: true},
        prefix: {type:String, required: true}
    },
    data() {
        return {
            isFileList: false,
            files: [],
            message: '',
        }
    },
    methods: {
        async upload(){
            async function getFileFromFileEntry(fileEntry) {
                return new Promise( (resolve) => {
                    fileEntry.file( (f) => {
                        resolve(f);
                    });
                });
            }
            let uploadFile = async (param, f) => {
                    let res = await utils.get( `/api/downloadurl/${this.bucketname}?${param}`);
                    let buff = await f.arrayBuffer();
                    res = await fetch(res['url'], {
                        method: "PUT", 
                        headers: {"Content-type": "application/pdf"},
                        mode: 'cors',
                        body: buff
                    });
                    if(!res.ok) {
                        throw new Error("アップロード失敗:" + f.name);
                    }

            }
            if(this.files.length == 0){ return; }
            let prefix = this.prefix.endsWith("/") ? this.prefix.slice(0, -1) : this.prefix;
            
            if(this.isFileList) {
                Array.from(this.files).forEach( async (f,i) => {
                    this.message = `${f.name} (${i}/${this.files.length})をアップロード中`;
                    let param = new URLSearchParams({obj:prefix + '/' + f.name, method:"PUT"});
                    await uploadFile(param, f);
                });
            } else {
                for(const [i, fs] of this.files.entries()){
                    this.message = `${fs.fullPath} (${i}/${this.files.length})をアップロード中`;
                    let param = new URLSearchParams({obj:prefix + fs.fullPath, method:"PUT"});
                    await uploadFile(param, await getFileFromFileEntry(fs));
                }
            }
            this.message = '';
            let len = this.files.length;
            this.files = [];
            console.log("UPLOAD FINISHED! emitting")
            this.$emit('upload-finished', len);
        },
        async readUrl(e) {
            var ret = [];
            async function rederWrap(entry) {
                return new Promise((resolve) => {
                    entry.createReader().readEntries( e => {
                        resolve(e);
                    });
                });
            }

            async function scanPdf(entry){
                if(entry.isDirectory){
                    let _subs = await rederWrap(entry)
                    for(let _sub of _subs) await scanPdf(_sub);
                }  else {
                    if(entry.name.endsWith(".pdf")){
                        ret.push(entry);
                    }
                }
            }
            if(e.target.webkitEntries && e.target.webkitEntries.length > 0 ){
                for(let _e of e.target.webkitEntries) await scanPdf(_e);
                this.files = ret;
                this.isFileList = false;
            } else {
                this.isFileList = true;
                this.files = e.target.files;
            }
        }
    },
    computed: {
    },
    watch: {
    },
}
</script>
<style scoped lang="scss">
.inputDnD {
  .form-control-file {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 6em;
    outline: none;
    visibility: hidden;
    cursor: pointer;
    background-color: #c61c23;
    box-shadow: 0 0 5px solid currentColor;
    &:before {
      content: attr(data-title);
      position: absolute;
      /* top: 0.5em; */
      left: 0;
      width: 100%;
      min-height: 6em;
      line-height: 2em;
      padding-top: 1.5em;
      opacity: 1;
      visibility: visible;
      text-align: center;
      border: 0.25em dashed currentColor;
      transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
      overflow: hidden;
    }
    &:hover {
      &:before {
        border-style: solid;
        box-shadow: inset 0px 0px 0px 0.25em currentColor;
      }
    }
  }
}

</style>

